import { render, staticRenderFns } from "./overlay-controls-lower.vue?vue&type=template&id=035fa19e"
import script from "./overlay-controls-lower.vue?vue&type=script&lang=js"
export * from "./overlay-controls-lower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports